const TimeRefresh = 1000

const isFromTx = 3 // 1 走腾讯 2 东方财富 3都走腾讯的
export function isStockMarketOpenGG() {
	// 获取当前时间的 UTC 时间戳
	  const hkTime = new Date();
	  // 获取当前时间对应的香港时间（HKT），通过时区转换
	  //const hkTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Hong_Kong' }));
	  
	  // 获取当前的星期（0 = Sunday, 1 = Monday, ..., 6 = Saturday）
	  const currentDay = hkTime.getDay();
	  // 如果是周六或周日，港股市场关闭
	  if (currentDay === 0 || currentDay === 6) {
	    return false;  // 港股周末不开盘
	  }
	  // 获取当前时间的小时和分钟
	  const currentHour = hkTime.getHours();
	  const currentMinute = hkTime.getMinutes();
	  // 港股的交易时间段：9:30 AM 到 12:00 PM， 1:00 PM 到 4:00 PM
	  const marketOpenHour = 9;
	  const marketOpenMinute = 30;
	  const marketLunchStartHour = 12;
	  const marketLunchEndHour = 13;
	  const marketCloseHour = 16;
	  // 判断是否在上午交易时间 9:30 AM - 12:00 PM 之间
	  if (
	    (currentHour > marketOpenHour || (currentHour === marketOpenHour && currentMinute >= marketOpenMinute)) &&
	    currentHour < marketLunchStartHour
	  ) {
	    return true;  // 上午开盘
	  }
	  
	  // 判断是否在下午交易时间 1:00 PM - 4:00 PM 之间
	  if (
	    (currentHour > marketLunchEndHour || (currentHour === marketLunchEndHour && currentMinute >= 0)) &&
	    currentHour < marketCloseHour
	  ) {
	    return true;  // 下午开盘
	  }
	  return false;  // 不在交易时间内
}
export function getMarketHours() {
	  const now = new Date();
	
	    // 计算美东时间（EST/EDT）
	    function getEasternTime(date) {
	        // 获取当前 UTC 时间（毫秒）
	        const utcTime = date.getTime() + date.getTimezoneOffset() * 60000;
	
	        // 计算是否是夏令时 (DST)
	        const januaryOffset = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
	        const julyOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
	        const isDST = date.getTimezoneOffset() < Math.max(januaryOffset, julyOffset);
	
	        // 根据 DST 设置美东时间偏移量
	        const estOffset = isDST ? -4 : -5;console.log(estOffset,'aa');
	        return new Date(utcTime + estOffset * 3600000);
	    }
	
	    const estTime = getEasternTime(now);
	
	    // 设定美股开盘（9:30 AM）和收盘（4:00 PM）时间
	    const openTime = new Date(estTime);
	    openTime.setHours(9, 30, 0, 0);
	
	    const closeTime = new Date(estTime);
	    closeTime.setHours(16, 0, 0, 0);
		
		console.log(openTime, closeTime, estTime)
	    return { openTime, closeTime, estTime };
}

// 判断是否为节假日
function isHoliday(date) {
    const holidays = [
        '2024-01-01', // 元旦
        '2024-07-04', // 独立日
        '2024-11-28', // 感恩节
        '2024-12-25', // 圣诞节
        // 添加更多节假日
    ];
    const dateString = date.toISOString().split('T')[0];
    return holidays.includes(dateString);
}
function isEasternDaylightTime(date){
	 const year = date.getUTCFullYear();
	    // 3月第2个星期日
	    const dstStart = new Date(Date.UTC(year, 2, 8)); // 3月8日是最早可能的 DST 开始日
	    while (dstStart.getUTCDay() !== 0) { dstStart.setUTCDate(dstStart.getUTCDate() + 1); }
	    // 11月第1个星期日
	    const dstEnd = new Date(Date.UTC(year, 10, 1)); // 11月1日是最早可能的 DST 结束日
	    while (dstEnd.getUTCDay() !== 0) { dstEnd.setUTCDate(dstEnd.getUTCDate() + 1); }
	    return date >= dstStart && date < dstEnd;
}
export function isStockMarketOpenMg() {
	const now = new Date();
	const estHour = now.getUTCHours();
	const utcMinutes = now.getUTCMinutes();
	const utcDay = now.getUTCDay(); // 0: 周日, 1: 周一, ..., 5: 周五, 6: 周六
	const isDST = isEasternDaylightTime(now);
	 const estOffset = isDST ? -4 : -5;
	 const estHours = estHour + estOffset;
	// 仅限周一到周五
	if (utcDay < 1 || utcDay > 5) {
	    return false;
	}
	// 美股正常交易时段（美东时间 09:30 - 16:00）对应 UTC 时间 13:30 - 20:00
	if (estHours < 9 || (estHours === 9 && utcMinutes < 30) || estHours >= 16) {
	    return false;
	}
	return true;    
}

export function isTradingTime() {
	const now = new Date();
	    const day = now.getDay(); // 0-6(日-六)
	    const hours = now.getHours();
	    const mins = now.getMinutes();
	    const timeValue = hours * 100 + mins;
	
	    // 周末/节假日判断(需自行补充节假日数组)
	    // const holidays = ['2025-01-01', '2025-01-28']; // 示例节假日
	    // const dateStr = now.toISOString().split('T')[0];
		// || holidays.includes(dateStr)
	    if (day === 0 || day === 6) {
	        return false;
	    }
	
	    // 交易时段判断
	    //const isMorningAuction = (timeValue >= 915 && timeValue < 930); // 集合竞价
	    const isMorningTrade = (timeValue >= 930 && timeValue < 1130);  // 上午交易
	    const isAfternoonTrade = (timeValue >= 1300 && timeValue < 1500);// 下午交易
	    //const isClosingAuction = (timeValue >= 1457 && timeValue < 1500);// 收盘竞价
	
	    if (isMorningTrade || isAfternoonTrade) {
	        return true;
	    } else {
	        return false;
	    }
}
export function isMaiListTime() {
	var date = new Date();
	//date = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' }));
	//判断是不是周末
	var dt = date.getDay();
	if (dt == '0' || dt == '6') {
		return false;
	}
	//判断当前时间是否在9:30-11:30, 13:00-15:00
	var h = date.getHours();
	var mi = date.getMinutes();
	var s = date.getSeconds();
	if (h < 10) {
		h = "0" + h;
	}
	if (mi < 10) {
		mi = "0" + mi;
	}
	if (s < 10) {
		s = "0" + s;
	}
	var curTime = h + ":" + mi + ":" + s;
	if (curTime >= "09:15:00" && curTime <= "09:25:00") {
		return true;
	}
	return false;
}
export function floorToFixed(value, n) {
	//if(!value) return 0
    const multiplier = Math.pow(10, n);
    return Math.floor(value * multiplier) / multiplier;
}
export function gobackLogin() {
	let token = uni.getStorageSync('token')
   if (token == undefined || !token){
     uni.navigateTo({
       url: '/pagesB/login/login'
     })
     return false
   }
   return true
}
// export default {
// 	TimeRefresh,
// 	isTradingTime,
// 	isFromTx,
// 	isMaiListTime,
// 	isStockMarketOpenMg,
// 	isStockMarketOpenGG,
// 	isEasternDaylightTime,
// 	floorToFixed,
// 	gobackLogin
// }
